import { Box, Grid, LinearProgress } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

export default function GridView({ acceptLeave, rejectLeave, acceptLoading, filteredRequests }) {
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }
    return (
        <Grid container spacing={2} className="mx-2 pr-4 pt-2 pl-4">
            {filteredRequests?.map((section, index) => {
                const date = new Date(section.updatedAt);
                let Applied = date.toLocaleTimeString();

                const from = new Date(
                    `${section.dates[0]?.month}-${section.dates[0]?.day}-${section.dates[0]?.year}`
                );

                const to = section.dates[1]
                    ? new Date(
                        `${section.dates[1]?.month}-${section.dates[1]?.day}-${section.dates[1]?.year}`
                    )
                    : new Date(
                        `${section.dates[0]?.month}-${section.dates[0]?.day}-${section.dates[0]?.year}`
                    );
                const timeDifference = Math.abs(from - to);
                const daysRemaining = Math.ceil(
                    timeDifference / (1000 * 60 * 60 * 24)
                );
                return (
                    <Grid key={index} item xs={12} sm={6} md={4}>
                        <Box
                            className="w-full ml-2 md:ml-0 rounded-lg"
                            sx={{ backgroundColor: "background.view" }}
                        >
                            <div className="flex justify-between items-center w-full">
                                <p
                                    className="mb-4 border-l-2 border-blue-500 pl-4 md:text-[18px] mt-2"
                                    gutterBottom
                                >
                                    Earned Leave Request
                                </p>
                                <button className="flex items-center text-white text-[8px] mr-2 md:mr-5 md:text-[10px] py-1 md:py-1 px-2 md:px-2 rounded bg-[#204050] hover:bg-sky-700">
                                    {daysRemaining ? daysRemaining + 1 : "1"} days
                                </button>
                            </div>
                            <div className="flex flex-row gap-2 mx-4">
                                <div className="flex justify-center items-center">
                                    <AccountCircleOutlinedIcon fontSize="large" />
                                </div>
                                <div className="flex flex-col">
                                    <h1 className="text-[16px]">{section.fullName}</h1>
                                    <p className="text-[10px] text-zinc-500">
                                        {section.department}
                                    </p>
                                </div>
                            </div>
                            <div
                                className="flex flex-row gap-4 mx-5 pt-2 "
                                style={{ marginTop: "3px", marginBottom: "3px" }}
                            >
                                <div className="flex justify-center items-center">
                                    <CalendarTodayOutlinedIcon fontSize="small" />
                                </div>
                                <p className="text-[16px]">
                                    {section.date}
                                    {section?.dates[0]?.year}-{section?.dates[0]?.month}
                                    -{section?.dates[0]?.day}
                                    {section?.dates.length > 1
                                        ? ` - ${section?.dates[section.dates.length - 1].year
                                        }-${section?.dates[section.dates.length - 1].month
                                        }-${section?.dates[section.dates.length - 1].day
                                        }`
                                        : ""}
                                </p>
                                <button className="flex text-center items-center text-white text-[8px] md:text-[10px]  px-2 md:px-2 rounded bg-[#204050] hover:bg-sky-700">
                                    {daysRemaining ? daysRemaining + 1 : "1"} days
                                </button>
                            </div>
                            <div className="flex flex-col w-[90%] md:ml-5 mx-4 gap-2">
                                <p className="text-[10px] text-zinc-500 mt-2">
                                    Applied On {formatDate(section.updatedAt)}
                                </p>

                                <LinearProgress
                                    variant="determinate"
                                    className="mb-2 w-[97%]"
                                    value={daysRemaining}
                                />
                            </div>
                            <div className="flex  justify-between items-center w-[85%] md:ml-5 mx-4">
                                <p
                                    className="md:text-[10px] pl-1 pt-1"
                                    gutterBottom
                                >
                                    Remaining Leaves
                                </p>
                                <p className="flex items-center text-[8px] md:text-[10px]">
                                    {daysRemaining}
                                </p>
                            </div>
                            <Box
                                className="mt-2 w-[90%] ml-3 flex  md:ml-5 rounded-lg"
                                sx={{ backgroundColor: "background.bond" }}
                            >
                                <div>
                                    <div className="flex flex-col p-2">
                                        <h1 className="text-[10px]">Reason</h1>
                                        <p className="text-[8px]">
                                            {section.reason}
                                        </p>
                                    </div>
                                </div>
                            </Box>
                            <div className="w-full flex justify-center items-center">
                                <div className="w-[90%]  flex flex-row gap-2 pb-2 mt-2 justify-center items-center">
                                    <div className="w-1/2 flex justify-center items-center">
                                        <button
                                            className="flex w-full justify-center items-center text-blue-500 text-[8px] md:text-[12px] py-1 md:py-1.5 px-2 md:px-2 border border-blue-500 rounded hover:bg-sky-700"
                                            onClick={() => acceptLeave(section?._id)}
                                            disabled={acceptLoading}
                                        >
                                            Accept
                                        </button>
                                    </div>
                                    <div className="w-1/2 flex justify-center items-center">
                                        <button
                                            className="flex w-full justify-center items-center text-red-500 text-[8px]  md:text-[12px] py-1 md:py-1.5 px-2 md:px-2 border border-red-500 rounded hover:bg-red-700"
                                            onClick={() => rejectLeave(section?._id)}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Box>
                    </Grid>
                );
            })}
        </Grid>
    )
}